<mat-spinner class="spinner" *ngIf="isLoading"></mat-spinner>
<frodo-page-shell [goBack]="redirect" [showConnectionIndicator]="true">
  <div shell-header class="delivery-list__header__title" data-testid="delivery-list-title">
    {{ 'common.selectOrder' | translate }}
  </div>

  <div class="delivery-list">
    <div class="delivery-list__control">
      <input
        type="text"
        class="delivery-list__control__input"
        id="code"
        #code
        autocomplete="off"
        [placeholder]="'common.search' | translate"
      />
      <button
        class="delivery-list__control__search-button"
        [disabled]="isLoading"
        (click)="search()"
        id="search-button"
      >
        {{ 'common.search' | translate }}
      </button>
    </div>
    <div class="delivery-list__buttons">
      <button
        [ngClass]="
          lastUpdateSelected
            ? 'delivery-list__buttons__selected'
            : 'delivery-list__buttons__unselected'
        "
        [disabled]="isLoading"
        (click)="lastUpdate()"
        id="last-update-button"
      >
        <mat-icon>watch_later</mat-icon>
        {{ 'common.lastUpdate' | translate }}
      </button>
      <button
        [ngClass]="
          firstCreatedSelected
            ? 'delivery-list__buttons__selected'
            : 'delivery-list__buttons__unselected'
        "
        [disabled]="isLoading"
        (click)="firstCreated()"
        id="first-created-button"
      >
        {{ 'common.firstCreated' | translate }}
      </button>
      <button
        *ngIf="handedOffEnabled"
        [ngClass]="
          handedOffModeActive
            ? 'delivery-list__buttons__toggle__enabled'
            : 'delivery-list__buttons__toggle'
        "
        [disabled]="isLoading"
        (click)="toggleHandedOffMode()"
        id="handed-off-button"
      >
        {{ 'common.handedOff.confirmButton' | translate }}
      </button>
      <frodo-select
        [ngClass]="
          dropdownSelected
            ? 'delivery-list__buttons__dropdown__selected'
            : 'delivery-list__buttons__dropdown'
        "
        (selectionChange)="selectChange($event)"
        [(ngModel)]="lastDropdownOption"
        [disabled]="isLoading"
      >
        <div frodo-select-value class="delivery-list__buttons__dropdown__text">
          {{ selectedFilterLabel | translate }}
        </div>
        <frodo-select-option
          class="delivery-list__buttons__dropdown__text"
          *ngFor="let option of filterOptions"
          [value]="option.value"
        >
          {{ option.label | translate }}
        </frodo-select-option>
      </frodo-select>
    </div>
    <div class="delivery-list__container">
      <mat-card class="delivery-list__container__orders" *ngFor="let order of paginatedOrders">
        <mat-card-content
          class="delivery-list__container__orders__order"
          (click)="loadProcess(order)"
          id="order-card"
        >
          <p>
            <b>{{ 'common.pickupCode' | translate }}</b>
            {{ order.clientCode }}
          </p>
          <p>
            <b>{{ 'common.name' | translate }}</b>
            {{ order.scheduleName }}
          </p>
          <p class="delivery-list__container__orders__order__create-time">
            {{ 'common.createTime' | translate }} {{ order.createDateTime | date : 'HH:mm' }}
          </p>
        </mat-card-content>
      </mat-card>
    </div>
    <mat-paginator
      class="delivery-list__paginator"
      #paginator
      (page)="handlePageEvent($event)"
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="pageIndex"
      [selectConfig]="paginatorSelectConfig"
    ></mat-paginator>
    <frodo-alpha-keyboard
      [viewType]="frodoContext"
      [side]="'REAR'"
      [ngClass]="showKeyboard ? 'showKeyboard' : 'hideKeyboard'"
      (deliveryListSearch)="search()"
    ></frodo-alpha-keyboard>
  </div>
</frodo-page-shell>
